import logo from './logo.svg';
import './App.css';
import { Client } from '@stomp/stompjs';
import { useEffect, useState } from 'react';
import fetchJsonp from "fetch-jsonp";
import 'typeface-roboto';

function App() {
  const [clicks, setClicks] = useState(0);
  const [emails, setEmails] = useState(0);

  const handleStompMessage = async (m) => {
    const message = JSON.parse(m.body);
    if (message['email_record']) {
      setEmails((counter) => counter + 1);
    }
  };

  useEffect(() => {
    const stompInit = () => {
      console.log("RUnning stompinit..");
      const stompUrl = `wss://${window.location.host}/ws`;
      const client = new Client({
        brokerURL: stompUrl,
        connectHeaders: {
          login: 'guest',
          passcode: 'guest',
          host: window.location.host,
          saslMechanism: 'ANONYMOUS'
        },  
        debug: function(str) {
          console.log('STOMP DEBUG: ' + str)
        },  
        heartbeatIncoming: 20000,
        heartbeatOutgoing: 20000,
        reconnectDelay: 1000,
        onStompError: (frame) => {
          console.log('STOMP: Got ERROR: ' + JSON.stringify(frame));
        }   
      }); 
      client.onConnect = (frame) => {
        console.log('STOMP: Got connect: ' + JSON.stringify(frame));
        // setStompClient(client);
        client.subscribe('/topic/admin', (message) => handleStompMessage(message));
      }   
      client.activate();
    };  
    const getCounters = async () => {
      fetchJsonp(`https://${window.location.host === 'localhost:8090' ? 'dev' : 'app'}.activistmailer.com${window.location.host === 'localhost:8090' ? ':8443' : ''}/api/v1/counters`,
                                  {jsonpCallback: 'callback'}
      ).then((data) => {
console.log(" GOT DATA 1");
        return data.json()
      }).then((counterData) => {
console.log(" GOT DATA 2");
console.log(" GOT DATA  counterData2: " + JSON.stringify(counterData));
        if (counterData['clicks']) {
          setClicks(counterData['clicks'])
          setEmails(counterData['emails']);
        }   
      });
    }
    getCounters();
    stompInit();
  }, []);

  return (
    <div style={{color: '#4099a0', fontSize: '24px', fontWeight: 'bold', fontFamily: 'Roboto, sans-serif'}}>{ new Number(emails).toLocaleString() }</div>
  );
}

export default App;
